
import {
    MODAL_OPEN,
    MODAL_CLOSE
} from '../constants/actionTypes';

export const modalOpen = payload => {
    return ({
        type: MODAL_OPEN,
        payload
    });
}

export const modalClose = () => ({
    type: MODAL_CLOSE
});